export default __webpack_public_path__ + "static/media/electricity.0e59ec45.svg";